import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function createOrUpdateDirectByModel(body) {
    const response = await axios.put(
        `${REACT_APP_API}/bonifications/directa/model`,
        body
    )

    return response?.data?.data
}
